import styled, { css } from 'styled-components';

import Footer from '../Footer';
import Header from '../Header';
import Panel from '../Panel';

const pageSpacing = 'var(--page-gutter-spacing)';

export const Page = styled.div`
  height: 100%;
  display: grid;
  grid-template-columns: 18rem 1fr 30rem;
  grid-template-rows: minmax(72px, auto) 1fr var(--page-footer-height);
  position: relative;
  background-color: var(--neutral-100);
  ${(props) => {
    let areas =
      '"header header header" "main main main" "footer footer footer"';
    let mainPadding = `0 ${pageSpacing};`;
    let layout = `
      ${Panel} {
        grid-area: main;
        padding: ${mainPadding};
        -webkit-transition: width 0.5s ease-in-out;
        -moz-transition: width 0.5s ease-in-out;
        -o-transition: width 0.5s ease-in-out;
        transition: width 0.5s ease-in-out;
      }
    `;
    if (props.variant === 'home') {
      areas = '"main main main" "main main main" "main main main"';
      mainPadding = `0 ${pageSpacing};`;
      layout = `
        & > ${Header} {
          padding: 0 ${pageSpacing};
        }
        ${Panel} {
          grid-area: main;
          padding: ${mainPadding};
          -webkit-transition: width 0.5s ease-in-out;
          -moz-transition: width 0.5s ease-in-out;
          -o-transition: width 0.5s ease-in-out;
          transition: width 0.5s ease-in-out;
        }
      `;
    }

    if (props.variant === 'calendar') {
      areas = '"header header" "left_pane main" "left_pane main"';
      mainPadding = `0 ${pageSpacing} 0 0;`;
      layout = `
        ${Panel} {
          grid-area: left_pane;
          padding-right: 0;
          padding-left: ${pageSpacing};
        }

        ${Panel} + ${Panel} {
          grid-area: main;
          padding: ${mainPadding};
          -webkit-transition: width 0.5s ease-in-out;
          -moz-transition: width 0.5s ease-in-out;
          -o-transition: width 0.5s ease-in-out;
          transition: width 0.5s ease-in-out;
        }
      `;
    }

    if (props.variant === 'list') {
      areas = '"header header header" "main main main" "main main main"';
      mainPadding = `0 ${pageSpacing};`;
      layout = `
        ${Panel} {
          grid-area: main;
          padding: ${mainPadding};
          -webkit-transition: width 0.5s ease-in-out;
          -moz-transition: width 0.5s ease-in-out;
          -o-transition: width 0.5s ease-in-out;
          transition: width 0.5s ease-in-out;
        }
      `;
    }
    if (props.variant === 'list_detail') {
      areas =
        '"header header header" "main main right_pane" "main main right_pane"';
      mainPadding = `0 0 0 ${pageSpacing};`;
      layout = `
        ${Panel} {
          grid-area: main;
          padding: ${mainPadding};
          -webkit-transition: width 0.5s ease-in-out;
          -moz-transition: width 0.5s ease-in-out;
          -o-transition: width 0.5s ease-in-out;
          transition: width 0.5s ease-in-out;
        }

        ${Panel} + ${Panel} {
          grid-area: right_pane;
          padding-left: 0;
          padding-right: ${pageSpacing};
        }
      `;
    }
    if (props.variant === 'list_large_detail') {
      areas =
        '"header header header" "main right_pane right_pane" "main right_pane right_pane"';
      mainPadding = `0 0 0 ${pageSpacing};`;
      layout = `
        ${Panel} {
          grid-area: main;
          padding: ${mainPadding};
          -webkit-transition: width 0.5s ease-in-out;
          -moz-transition: width 0.5s ease-in-out;
          -o-transition: width 0.5s ease-in-out;
          transition: width 0.5s ease-in-out;
        }

        ${Panel} + ${Panel} {
          grid-area: right_pane;
          padding-left: 0;
          padding-right: ${pageSpacing};
        }
      `;
    }
    if (props.variant === 'filter_list') {
      areas =
        '"header header header" "left_pane main main" "left_pane main main"';
      mainPadding = `0 ${pageSpacing} 0 0;`;
      layout = `
        ${Panel} {
          grid-area: left_pane;
          padding-right: 0;
          padding-left: ${pageSpacing};
        }
        ${Panel} + ${Panel} {
          grid-area: main;
          padding: ${mainPadding};
          -webkit-transition: width 0.5s ease-in-out;
          -moz-transition: width 0.5s ease-in-out;
          -o-transition: width 0.5s ease-in-out;
          transition: width 0.5s ease-in-out;
        }
      `;
    }
    if (props.variant === 'filter_list_detail') {
      areas =
        '"header header header" "left_pane main right_pane" "left_pane main right_pane"';
      mainPadding = `0 0 0 0;`;
      layout = `
        ${Panel} {
          grid-area: left_pane;
          padding-right: 0;
          padding-left: ${pageSpacing};
        }
        ${Panel} + ${Panel} {
          grid-area: main;
          padding: ${mainPadding};
          -webkit-transition: width 0.5s ease-in-out;
          -moz-transition: width 0.5s ease-in-out;
          -o-transition: width 0.5s ease-in-out;
          transition: width 0.5s ease-in-out;
        }

        ${Panel} + ${Panel} + ${Panel} {
          grid-area: right_pane;
          padding-left: 0;
          padding-right: ${pageSpacing};
        }
      `;
    }
    return css`
      grid-template-areas: ${areas};
      column-gap: ${pageSpacing};
      & > ${Header} {
        grid-area: header;
        padding: 0 ${pageSpacing};
      }
      & > ${Footer} {
        grid-area: footer;
        align-items: center;
        padding: 0 ${pageSpacing};
      }
      ${layout}
      & > ${Panel} {
        padding-top: 1rem;
      }
      & > ${Panel} + ${Panel} {
        padding-top: 1rem;
      }
    `;
  }}
`;

export default Page;
